<template>
  <div>
    <div class="title">
      <h1 style="font-weight: bold;">产品信息</h1>
      <img src="@/assets/imgs/order/3.1 返回1@2x(1).png" alt="" @click="toggleShow">
    </div>
    <div class="commodity-info" v-if="showDetails">
      <div class="message">
        <span class="info-title">产品编码</span>
        <span class="info-value">{{ orderDetail.materialCode }}</span>
      </div>
      <div class="message" style="display: flex;">
        <span class="info-title">属性描述</span>
        <span class="info-value" style="flex:1">{{ orderDetail.description }}</span>
      </div>
      <div class="message">
        <span class="info-title">价格方式</span>
        <span class="info-value"> {{ orderDetail.saleMode | priceTypeStatus }}</span>
      </div>
      <div class="message">
        <span class="info-title">月计划量</span>
        <span class="info-value">
          <span class="colo-gr">{{advanceSalePlanInfo.planQuantityPerMonth}}</span>
          {{ orderDetail.measureUnit }}（已完成
          <span class="colo-gr">{{ advanceSalePlanInfo.planExecuteQuantityPerMonth}}</span>
          {{ orderDetail.measureUnit }}，完成率：
          <span class="colo-gr">{{ advanceSalePlanInfo.executeRate }}</span> ）</span>
      </div>
      <div class="message">
        <span class="info-title">订单重量</span>
        <span class="colo-gr">{{ orderDetail.quantity }}</span>
        {{ orderDetail.measureUnit }}
        &nbsp;&nbsp;
        <span>超发限制：</span>
        <span>{{ orderDetail.excessesPercentLimit }}%以内</span>
      </div>
      <div class="message">
        <span class="info-title">下单单价（含税）</span>
        <span class="info-value">
          <span class="colo-gr">{{ orderDetail.price }}</span>
          元/{{ orderDetail.measureUnit }}
        </span>
      </div>
      <div class="message">
        <span class="info-title">运费单价（含税）</span>
        <span class="info-value">
          <span class="colo-gr">{{ orderDetail.freightUnit }}</span>
          元/{{ orderDetail.measureUnit }}
        </span>
      </div>
      <div class="message">
        <span class="info-title">单价激励（含税）</span>
        <span class="info-value">
          <span class="colo-gr">{{ orderDetail.incentiveUnit || 0 }}</span>
          元/{{ orderDetail.measureUnit }}
        </span>
      </div>
      <div class="message">
        <span class="info-title">产品名称</span>
        <span class="info-value">{{ orderDetail.commodityName }}</span>
      </div>
      <div class="message">
        <span class="info-title">产品用途</span>
        <span class="info-value">{{ orderDetail.usageName }}</span>
      </div>
      <div class="message">
        <span class="info-title">发货方式</span>
        <span class="info-value">{{
            $utils.getCodeNameByCode(
                formInit.sendType,
                orderDetail.shipMode
            )
          }}</span>
      </div>
      <div class="message">
        <span class="info-title">发货仓库</span>
        <span class="info-value">{{ orderDetail.warehouseName }}</span>
      </div>
      <div class="message">
        <span class="info-title">订单单价（含税）</span>
        <span class="colo-gr">{{ orderDetail.price }}</span>
        <span> 元/{{ orderDetail.measureUnit }}</span>
      </div>
      <div class="message">
        <span class="info-title">订单金额（含税）</span>
        <span class="colo-gr">{{ orderDetail.amount }}</span> 元
      </div>
      <div class="message">
        <span class="info-title">ERP可用余额</span>
        <span class="colo-gr">{{ orderDetail.erpAccountBalance }}</span>
        <span>元</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderCommodityCard",
  props: {
    orderDetail: Object,
    advanceSalePlanInfo: Object,
  },
  data() {
    return {
      showDetails: true, // 控制价格详情是否显示
      formInit: {
        orderType: [],
        priceType: [
          {
            itemCode: "02",
            itemName: "定价",
          },
          {
            itemCode: "01",
            itemName: "挂牌",
          },
        ],
        sendType: [
          {
            itemCode: "Z",
            itemName: "直发",
          },
          {
            itemCode: "K",
            itemName: "库发",
          },
          {
            itemCode: "D",
            itemName: "断卖",
          },
        ],
        deliveryType: [
          {
            itemCode: "1",
            itemName: "自提",
          },
          {
            itemCode: "2",
            itemName: "配送",
          },
        ],
        status: [
          //订单状态
          {
            itemName: "已撤销",
            itemCode: "-1",
          },
          {
            itemName: "待提交",
            itemCode: "0",
          },
          {
            itemName: "待确认",
            itemCode: "0_1", //其他交易模式
          },
          {
            itemName: "待确认",
            itemCode: "0_2", //待客户下单
          },
          {
            itemName: "待确认",
            itemCode: "0_3", //业务员初审之后再确认
          },
          {
            itemName: "待审核",
            itemCode: "1",
          },
          {
            itemName: "审核中",
            itemCode: "2",
          },
          {
            itemName: "待发货",
            itemCode: "3",
          },
          {
            itemName: "发货中",
            itemCode: "4",
          },
          {
            itemName: "已完成",
            itemCode: "9",
          },
        ],
      },
    };
  },
  filters: {
    shipModeStatus: function (value) {
      switch (value) {
        case "Z":
          return "直发";
        case "K":
          return "库发";
        case "D":
          return "断卖";
      }
    },

    priceTypeStatus: function (value) {
      switch (value) {
        case "02":
          return "定价";
        case "01":
          return "挂牌";
      }
    },
  },
  created() {
    console.log("orderDetail", this.orderDetail);
  },
  methods: {
    toggleShow() {
      this.showDetails = !this.showDetails; // 切换显示状态
    },
  }
};
</script>
<style lang="stylus" scoped>
.title {
  margin: 32px 0;
  padding: 0 34px;
  display: flex;
  justify-content: space-between;

  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
  }

  img {
    width: 32px;
    height: 32px;
  }
}

.commodity-info {
  overflow: hidden;
  background-color: #fff;
  margin: 32px 0;
  padding: 0 32px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 28px;

  .message {
    margin: 40px 0;

    .info-title {
      margin-right: 48px;
      color: #666666;
    }

    .info-value {
      color: #333;
    }
  }

  .message-title {
    margin-top: 48px;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
  }
}

.colo-gr {
  color: #FF7530;
}
</style>